function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

// 分转化为元（两位小数）
export function amount(number){
  let num = parseInt(number)
  return isNaN(num) ? 0.00 : Number((num/100)).toFixed(2)
}
// 分转化为元（四位小数）
export function amountFixed4(number){
  // let num = parseInt(number)
  return isNaN(number) ? 0.00 : Number((number/100)).toFixed(4)
}
//商品状态
export function productStatus(status) {
  let statusList = {'1': '待审核', '2': '机审通过', '3': '机审失败', '4': '人审通过', '5': '人审失败', '6': '上架', '7': '下架', '8': '禁用','9':'待上架'}
  return statusList[status]
}
//商户类型
export function sellerType(type) {
  let sellerTypeList= {'1':'长期商户','2':'临时商户'}
  return sellerTypeList[type]
}
//千分位
export function threePartMethod(money) {
  if (money && money != null) {
    money = String(money);
    var left = money.split('.')[0], right = money.split('.')[1];
    right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
    var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
    return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
  } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return '0.00';
  } else {
    return '';
  }
}
//订单状态
export function orderStatus(status) {
  let statusList = {
    '1': '待付款',
    '2': '发起支付',
    '3': '取消中',
    '4': '待发货(待自提)',
    '5': '退单中',
    '6': '发货中',
    '7': '待收货',
    '8': '交易完成',
    '9':'交易关闭',
    '10':'挂起',
    '11':'删除',
    '12':'待买家确认',
    '14':'待卖家确认预售'
  }
  return statusList[status]
}



// WEBPACK FOOTER //
// ./src/filters/index.js